function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWritingVector(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 500 500",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "freepik--background-complete--inject-75"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 52.67,
    y: 111.75,
    width: 166.63,
    height: 7.31,
    transform: "translate(271.97 230.81) rotate(180)",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 202.65,
    y: 119.06,
    width: 7.31,
    height: 24.17,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 202.65,
    y: 119.06,
    width: 7.31,
    height: 7.47,
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 62.01,
    y: 119.06,
    width: 7.31,
    height: 24.17,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 62.01,
    y: 119.06,
    width: 7.31,
    height: 7.47,
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 159.05,
    y: 82.6,
    width: 46.57,
    height: 11.73,
    transform: "translate(270.8 -93.87) rotate(90)",
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 179.78,
    y: 59.39,
    width: 5.12,
    height: 11.73,
    transform: "translate(247.59 -117.08) rotate(90)",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 181.39,
    y: 69.45,
    width: 1.9,
    height: 11.73,
    transform: "translate(257.65 -107.02) rotate(90)",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 179.05,
    y: 96.49,
    width: 5.12,
    height: 13.19,
    transform: "translate(284.69 -78.52) rotate(90)",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 145.21,
    y: 80.49,
    width: 54.33,
    height: 8.2,
    transform: "translate(256.96 -87.78) rotate(90)",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 161.96,
    y: 70.52,
    width: 20.89,
    height: 4.92,
    transform: "translate(245.39 -99.43) rotate(90)",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 105,
    y: 85.66,
    width: 54.33,
    height: 8.2,
    transform: "translate(289.25 60.68) rotate(135.33)",
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 118.87,
    y: 90.06,
    width: 20.89,
    height: 4.92,
    transform: "translate(286.34 67.42) rotate(135.33)",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 140.69,
    y: 84.17,
    width: 41.26,
    height: 13.92,
    transform: "translate(252.45 -70.19) rotate(90)",
    style: {
      fill: "#a6a6a6"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 159.4,
    y: 98.51,
    width: 3.85,
    height: 13.92,
    transform: "translate(266.79 -55.86) rotate(90)",
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 160.58,
    y: 93.31,
    width: 1.49,
    height: 13.92,
    transform: "translate(261.59 -61.05) rotate(90)",
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 173.62,
    y: 87.57,
    width: 38.78,
    height: 9.61,
    transform: "translate(285.38 -100.63) rotate(90)",
    style: {
      fill: "#a6a6a6"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 191.2,
    y: 101.04,
    width: 3.61,
    height: 9.61,
    transform: "translate(298.85 -87.16) rotate(90)",
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 191.2,
    y: 77.98,
    width: 3.61,
    height: 9.61,
    transform: "translate(275.79 -110.22) rotate(90)",
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 192.31,
    y: 82.96,
    width: 1.4,
    height: 9.61,
    transform: "translate(280.77 -105.24) rotate(90)",
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M418.57,310.91H242.3V58.43H418.57Zm-171.13-5.15h166V63.58h-166Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 325.86,
    y: 64.92,
    width: 5.14,
    height: 243.41,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 237.63,
    y: 68.83,
    width: 185.6,
    height: 7.16,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 237.63,
    y: 76.89,
    width: 185.6,
    height: 7.16,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 237.63,
    y: 84.95,
    width: 185.6,
    height: 7.16,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 237.63,
    y: 93.01,
    width: 185.6,
    height: 7.16,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 237.63,
    y: 101.07,
    width: 185.6,
    height: 7.16,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 237.63,
    y: 109.13,
    width: 185.6,
    height: 7.16,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 237.63,
    y: 117.19,
    width: 185.6,
    height: 7.16,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 237.63,
    y: 125.25,
    width: 185.6,
    height: 7.16,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 237.63,
    y: 133.31,
    width: 185.6,
    height: 7.16,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 406.67,
    y: 67.38,
    width: 1.29,
    height: 139.4,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "409.6 212.77 405.03 212.77 406.18 206.21 408.45 206.21 409.6 212.77",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 411.3,
    y: 67.38,
    width: 1.29,
    height: 213.15,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "414.23 285.35 409.66 285.35 410.81 278.79 413.08 278.79 414.23 285.35",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 229.65,
    y: 57.43,
    width: 201.57,
    height: 14.99,
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 46.11,
    y: 291.36,
    width: 26.48,
    height: 11.19,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 31.34,
    y: 305.47,
    width: 26.48,
    height: 11.19,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 147.94,
    y: 207.33,
    width: 26.48,
    height: 11.19,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 133.17,
    y: 221.44,
    width: 26.48,
    height: 11.19,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 118.46,
    y: 207.33,
    width: 26.48,
    height: 11.19,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 442.18,
    y: 305.47,
    width: 26.48,
    height: 11.19,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 427.41,
    y: 87.01,
    width: 26.48,
    height: 11.19,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 442.18,
    y: 101.12,
    width: 26.48,
    height: 11.19,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 46.11,
    y: 87.01,
    width: 26.48,
    height: 11.19,
    style: {
      fill: "#ebebeb"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Shadow--inject-75"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 250,
    cy: 416.08,
    rx: 195.2,
    ry: 35.05,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 104.5,
    cy: 387.03,
    rx: 41.94,
    ry: 8.28,
    style: {
      fill: "#ebebeb"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Plant--inject-75"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M389.77,259.7c15.39,15.06,18,38.37,14.73,58.79-.09.46-.8.33-.8-.1,0-4.65.14-9.25.12-13.85-.08-.21-.15-.4-.24-.61-4-2.92-7.71-6.22-10-10.75-2.57-5.05-3.58-10.75-5.55-16-.18-.51.36-.36.71-.1,9.36,6.91,12.34,14.34,15,24.26a82.73,82.73,0,0,0-1.63-15.45c-2-9.43-6-18.76-12.79-25.76A.29.29,0,0,1,389.77,259.7Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M386.87,261.45c-2.64.09-4.3,4.32-6.37,5.56a2,2,0,0,1-2.92-.46c-2-2.85.76-6.37,3.4-8.34-1.89.77-3.45,2.14-5.48,2.52a1.91,1.91,0,0,1-2.48-1.48c-.9-3.89,4-5.62,7.33-5.7-1.62-1.13-6.27-4.2-3.8-5.71s8,2.87,9.74,4.32c2.62,2.12,5.74,5.29,5.86,8.62C392.3,264.65,388.91,262.27,386.87,261.45Z",
    style: {
      fill: "#009595"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M386.87,261.45c-2.64.09-4.3,4.32-6.37,5.56a2,2,0,0,1-2.92-.46c-2-2.85.76-6.37,3.4-8.34-1.89.77-3.45,2.14-5.48,2.52a1.91,1.91,0,0,1-2.48-1.48c-.9-3.89,4-5.62,7.33-5.7-1.62-1.13-6.27-4.2-3.8-5.71s8,2.87,9.74,4.32c2.62,2.12,5.74,5.29,5.86,8.62C392.3,264.65,388.91,262.27,386.87,261.45Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M387.64,262.11c-3.38-1.54-9.89.67-10.44-.61-1.12-2.61,4.08-4.4,6.88-4.74-2.58-.7-7.53-1.82-7.38-4.31.19-3,7.59-.42,11.34,2.45,4.72,3.62,4.69,7.11,3.91,7.81C390.88,263.67,388.2,262.36,387.64,262.11Z",
    style: {
      fill: "#009595"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M424.81,258.21c-15.95,14.47-19.41,37.66-16.95,58.18.07.47.79.37.8-.07.18-4.64.22-9.25.4-13.83.1-.21.17-.41.27-.61,4.12-2.77,7.94-5.93,10.39-10.36,2.76-4.95,4-10.61,6.16-15.81.2-.5-.35-.37-.71-.12-9.62,6.54-12.88,13.85-15.94,23.67a82.88,82.88,0,0,1,2.21-15.39c2.38-9.33,6.74-18.51,13.77-25.24A.29.29,0,0,0,424.81,258.21Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M427.64,260.07c2.64.19,4.14,4.48,6.15,5.79a2,2,0,0,0,2.94-.34c2.15-2.78-.52-6.4-3.08-8.47,1.86.85,3.37,2.27,5.38,2.73a1.92,1.92,0,0,0,2.54-1.39c1-3.85-3.77-5.76-7.11-6,1.66-1.07,6.43-4,4-5.56s-8.07,2.57-9.91,3.94c-2.69,2-5.93,5.08-6.18,8.39C422.09,263.06,425.57,260.81,427.64,260.07Z",
    style: {
      fill: "#009595"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M427.64,260.07c2.64.19,4.14,4.48,6.15,5.79a2,2,0,0,0,2.94-.34c2.15-2.78-.52-6.4-3.08-8.47,1.86.85,3.37,2.27,5.38,2.73a1.92,1.92,0,0,0,2.54-1.39c1-3.85-3.77-5.76-7.11-6,1.66-1.07,6.43-4,4-5.56s-8.07,2.57-9.91,3.94c-2.69,2-5.93,5.08-6.18,8.39C422.09,263.06,425.57,260.81,427.64,260.07Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M426.85,260.69c3.44-1.41,9.85,1.06,10.45-.2,1.22-2.57-3.9-4.55-6.69-5,2.61-.61,7.59-1.53,7.54-4-.07-3-7.57-.71-11.43,2-4.85,3.44-5,6.93-4.2,7.66C423.55,262.14,426.28,260.93,426.85,260.69Z",
    style: {
      fill: "#009595"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M408.5,296.42a157.77,157.77,0,0,1-4.95,22.88.57.57,0,0,1-1.11-.23c1-7.05,2.95-14,4-21a106,106,0,0,0,1.23-21.58C407,264.59,403.77,252,396,242.66c-.18-.22.19-.53.36-.33,15.52,18.1,13.05,40.29,13,42.27,2.2-7.49,4.46-16.08,12.77-23.7.36-.33.64-.18.58.38-1.48,13.9-5.35,21.15-13.4,28.58Q409,293.17,408.5,296.42Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M395.87,244.74c-2.79-1.24-6.64,2.31-9.4,2.56a2.29,2.29,0,0,1-2.8-2c-.69-4,4-6.23,7.72-6.95-2.34-.14-4.65.49-7-.14a2.2,2.2,0,0,1-1.82-2.78c1-4.49,7-3.83,10.48-2.23-1.12-2-4.4-7.51-1.08-7.83s6.82,7,7.94,9.38c1.65,3.52,3.29,8.38,1.74,11.89C399.89,250.79,397.58,246.61,395.87,244.74Z",
    style: {
      fill: "#009595"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M395.87,244.74c-2.79-1.24-6.64,2.31-9.4,2.56a2.29,2.29,0,0,1-2.8-2c-.69-4,4-6.23,7.72-6.95-2.34-.14-4.65.49-7-.14a2.2,2.2,0,0,1-1.82-2.78c1-4.49,7-3.83,10.48-2.23-1.12-2-4.4-7.51-1.08-7.83s6.82,7,7.94,9.38c1.65,3.52,3.29,8.38,1.74,11.89C399.89,250.79,397.58,246.61,395.87,244.74Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M396.34,245.8c-2.74-3.3-10.6-4.27-10.53-5.88.15-3.27,6.44-2.51,9.53-1.46-2.33-2-6.9-5.67-5.49-8.18,1.72-3.06,8.09,3.38,10.53,8.25,3.08,6.13,1.29,9.74.13,10.07C398.91,249.06,396.79,246.35,396.34,245.8Z",
    style: {
      fill: "#009595"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M418.71,300.6l6.85,52.31H383.9c.86-4.64,8.62-52.37,8.62-52.37Z",
    style: {
      fill: "#009595"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Desk--inject-75"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "47.44 352.76 98.08 352.51 148.72 352.43 250 352.26 351.28 352.42 401.92 352.51 452.56 352.76 401.92 353 351.28 353.09 250 353.26 148.72 353.09 98.08 353 47.44 352.76",
    style: {
      fill: "#263238"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Notes--inject-75"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "346.31 408.18 376.48 390.36 414.81 403.19 383.33 422.32 346.31 408.18",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M382.14,417.36c1.85-1.37,3.76-2.64,5.68-3.91s3.88-2.47,5.83-3.67,3.94-2.37,6-3.48l3-1.67c1-.53,2-1.08,3.08-1.58-.93.69-1.88,1.33-2.82,2L400,407c-1.92,1.27-3.87,2.48-5.83,3.68s-3.94,2.36-5.95,3.48S384.21,416.34,382.14,417.36Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M387.12,410.12a59.82,59.82,0,0,1,6.75-4.69,59.22,59.22,0,0,1,7.27-3.83,67.21,67.21,0,0,1-14,8.52Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M373.05,414.46c1.85-1.37,3.76-2.64,5.69-3.9s3.87-2.48,5.82-3.68,3.94-2.36,5.95-3.48l3-1.67c1-.52,2-1.08,3.07-1.58-.93.69-1.88,1.33-2.82,2l-2.87,1.91c-1.92,1.27-3.87,2.47-5.83,3.67s-3.94,2.37-5.95,3.48S375.12,413.45,373.05,414.46Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M371.89,411c3.15-2.38,6.47-4.5,9.82-6.56s6.77-4,10.34-5.7c-3.15,2.38-6.47,4.5-9.82,6.56S375.45,409.25,371.89,411Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M375.83,404.35a40.69,40.69,0,0,1,5.58-4,40.25,40.25,0,0,1,6.1-3.12,40.69,40.69,0,0,1-5.58,4A41.22,41.22,0,0,1,375.83,404.35Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "282.61 421.3 330.27 402.68 376.26 430.41 328.84 449.69 282.61 421.3",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M328.17,444c3.1-1.48,6.25-2.86,9.4-4.23s6.33-2.69,9.5-4,6.38-2.57,9.59-3.78l4.83-1.81c1.62-.57,3.23-1.17,4.87-1.71-1.55.75-3.12,1.44-4.68,2.17L357,432.76c-3.14,1.37-6.32,2.68-9.5,4s-6.37,2.57-9.59,3.78S331.43,442.94,328.17,444Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M340.38,434.17c3.4-1.8,6.91-3.33,10.45-4.79s7.13-2.78,10.83-3.86c-3.4,1.81-6.91,3.33-10.45,4.79S344.08,433.09,340.38,434.17Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M323.47,436.14c2.71-1.32,5.47-2.55,8.23-3.76s5.54-2.36,8.33-3.51,5.59-2.25,8.41-3.3l4.24-1.57c1.43-.49,2.84-1,4.28-1.47-1.35.67-2.73,1.28-4.09,1.92l-4.14,1.84c-2.75,1.21-5.54,2.36-8.33,3.51s-5.59,2.24-8.41,3.29S326.34,435.2,323.47,436.14Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M321.25,432.14c2.51-1.25,5.06-2.39,7.61-3.51s5.13-2.2,7.71-3.26,5.18-2.08,7.8-3.05l3.92-1.44c1.33-.45,2.64-.93,4-1.35-1.25.63-2.52,1.2-3.78,1.8L344.65,423c-2.55,1.13-5.12,2.19-7.7,3.26s-5.18,2.07-7.8,3S323.91,431.28,321.25,432.14Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M309.38,432.06c3.1-1.49,6.25-2.87,9.4-4.24s6.32-2.68,9.5-4,6.38-2.56,9.59-3.77l4.83-1.81c1.62-.57,3.23-1.18,4.86-1.72-1.54.75-3.12,1.45-4.68,2.17l-4.72,2.07c-3.15,1.38-6.32,2.68-9.5,4s-6.38,2.56-9.59,3.77S312.64,431,309.38,432.06Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M309,427.31c2.75-1.34,5.54-2.57,8.33-3.8s5.61-2.39,8.43-3.55,5.65-2.27,8.51-3.34l4.29-1.59c1.44-.5,2.87-1,4.33-1.49-1.37.67-2.77,1.29-4.15,1.95l-4.18,1.85c-2.79,1.23-5.61,2.39-8.43,3.55s-5.65,2.27-8.51,3.33S311.88,426.35,309,427.31Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M300,426.07c3.11-1.49,6.25-2.87,9.4-4.24s6.33-2.69,9.51-4,6.37-2.57,9.59-3.78l4.82-1.81c1.63-.57,3.23-1.17,4.87-1.71-1.55.75-3.12,1.44-4.68,2.17l-4.72,2.07c-3.15,1.38-6.33,2.68-9.51,4s-6.37,2.56-9.59,3.77S303.24,425,300,426.07Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M310.9,416.72c3.61-1.89,7.34-3.51,11.1-5.05s7.56-3,11.47-4.13c-3.61,1.9-7.34,3.51-11.1,5S314.81,415.55,310.9,416.72Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "181.38 395.32 318.18 359.3 381.83 393.41 248.01 438 181.38 395.32",
    style: {
      fill: "#009595"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M189.86,394.7l61,39.22,125.41-41.69-61.53-32.68s-37.53,4.94-39.28,5.48-18.3,7.42-18.3,7.42-23.22,4-24.79,4.56S189.86,394.7,189.86,394.7Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "257.17 372.45 264.62 377.27 272.02 382.17 286.76 392.06 301.41 402.09 308.69 407.16 315.94 412.29 308.49 407.46 301.08 402.57 286.34 392.68 271.7 382.64 264.42 377.58 257.17 372.45",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M268.82,401c1.58-.51,3.19-.95,4.8-1.38s3.23-.81,4.85-1.19,3.26-.72,4.9-1,3.28-.6,4.94-.82c-1.59.52-3.2,1-4.81,1.38s-3.22.81-4.84,1.19-3.25.72-4.89,1S270.49,400.8,268.82,401Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M240.84,417.35c4.13-2,8.3-3.86,12.47-5.73s8.37-3.7,12.57-5.52c2.1-.92,4.21-1.79,6.35-2.64a10.7,10.7,0,0,1,1.68-.5l1.68-.39,3.35-.74c4.48-.94,9-1.86,13.46-2.68-4.43,1.15-8.88,2.21-13.33,3.28l-3.33.79a25.12,25.12,0,0,0-3.26.9c-2.11.84-4.2,1.78-6.31,2.65l-12.64,5.35C249.31,413.89,245.09,415.65,240.84,417.35Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M245.11,420.16c4-2,8-3.83,12.08-5.69s8.11-3.66,12.17-5.47c2-.91,4.08-1.78,6.14-2.63.52-.21,1-.43,1.58-.62s1.1-.28,1.64-.42l3.26-.73c4.35-.92,8.71-1.81,13.09-2.6-4.3,1.13-8.63,2.16-12.95,3.22l-3.24.77c-.54.14-1.09.26-1.59.43s-1,.39-1.52.6l-6.12,2.64c-4.09,1.75-8.14,3.58-12.24,5.31S249.23,418.46,245.11,420.16Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M249.35,422.48q6.12-2.69,12.31-5.21c4.11-1.73,8.26-3.35,12.4-5,2.08-.82,4.12-1.65,6.29-2.36l6.43-1.81c4.3-1.15,8.61-2.32,12.94-3.38-4.24,1.4-8.5,2.69-12.76,4l-6.42,1.88c-2.06.7-4.14,1.58-6.22,2.36-4.16,1.59-8.29,3.26-12.46,4.83S253.54,421,249.35,422.48Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M310.79,402.17c3.79-1.85,7.64-3.56,11.54-5.16,1-.4,1.95-.81,2.94-1.17.5-.18,1-.37,1.53-.52l1.53-.41,6.11-1.62c4.06-1.1,8.15-2.12,12.23-3.18s8.16-2.08,12.26-3.08c-4.05,1.19-8.09,2.36-12.15,3.5s-8.11,2.3-12.17,3.39l-6.1,1.67L327,396c-.47.14-1,.33-1.46.52l-2.94,1.13C318.68,399.21,314.76,400.75,310.79,402.17Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M306.66,398.94q5.65-2.37,11.41-4.42c1.93-.68,3.83-1.4,5.84-1.93l5.9-1.61c3.92-1.09,7.87-2.11,11.81-3.16s7.89-2.06,11.85-3.05c-3.91,1.18-7.81,2.35-11.73,3.48s-7.83,2.28-11.76,3.37l-5.89,1.66c-1,.25-1.92.6-2.89.92l-2.9,1C314.45,396.5,310.57,397.77,306.66,398.94Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M302.68,396.07q5.63-2.32,11.35-4.36c1.91-.67,3.8-1.38,5.77-2l5.91-1.44c3.93-1,7.87-1.87,11.82-2.8s7.89-1.81,11.85-2.68c-3.91,1.07-7.82,2.12-11.74,3.12s-7.84,2-11.77,3c-1.95.49-3.94,1-5.87,1.48l-5.75,1.91Q308.51,394.33,302.68,396.07Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M299.28,394c3.6-1.94,7.29-3.64,11.06-5.23.47-.2.94-.38,1.43-.55a10.41,10.41,0,0,1,1.52-.42l3-.65,6-1.28c8-1.65,15.95-3.28,23.95-4.8-7.92,1.88-15.87,3.66-23.81,5.43l-6,1.32-3,.67a17.81,17.81,0,0,0-2.83,1C306.85,390.91,303.11,392.54,299.28,394Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M295.55,391.35c3.6-1.93,7.29-3.64,11.06-5.22.47-.2.94-.38,1.44-.55a10,10,0,0,1,1.51-.42l3-.65,6-1.28c8-1.66,15.95-3.28,23.95-4.8-7.92,1.88-15.87,3.66-23.81,5.43l-6,1.32-3,.67a16,16,0,0,0-2.83,1C303.12,388.32,299.38,390,295.55,391.35Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M291.82,388.76c3.6-1.93,7.29-3.64,11.06-5.22.47-.2.95-.39,1.44-.56a10.24,10.24,0,0,1,1.51-.41l3-.66,6-1.27c8-1.66,16-3.28,24-4.8-7.92,1.87-15.87,3.65-23.81,5.43l-6,1.31-3,.68a16,16,0,0,0-2.83,1C299.39,385.72,295.66,387.36,291.82,388.76Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M288.09,386.17c3.6-1.94,7.29-3.64,11.06-5.23.47-.2,1-.38,1.44-.55a10.28,10.28,0,0,1,1.51-.42l3-.65,6-1.27c8-1.66,15.95-3.29,23.95-4.8-7.92,1.87-15.86,3.65-23.81,5.43l-6,1.31-3,.67a16.91,16.91,0,0,0-2.83,1C295.66,383.13,291.93,384.77,288.09,386.17Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M283.28,384.08c3.6-1.93,7.29-3.63,11.06-5.22.47-.2,1-.38,1.44-.55a10.28,10.28,0,0,1,1.51-.42l3-.65,6-1.28c8-1.66,15.95-3.28,23.95-4.8-7.92,1.88-15.86,3.66-23.81,5.43l-6,1.32-3,.67a17.81,17.81,0,0,0-2.83,1C290.85,381.05,287.12,382.68,283.28,384.08Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M278.61,382c3.59-1.93,7.29-3.63,11.05-5.22.47-.2.95-.38,1.44-.55a10.64,10.64,0,0,1,1.51-.42l3-.65,6-1.28c8-1.66,15.94-3.28,23.94-4.8-7.92,1.88-15.86,3.66-23.81,5.43l-6,1.32-3,.67a17.59,17.59,0,0,0-2.84,1C286.17,379,282.44,380.62,278.61,382Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M274.88,379.43c3.58-1.93,7.27-3.63,11-5.22.47-.2.94-.38,1.43-.55a9.25,9.25,0,0,1,1.52-.41l3-.61,6-1.17c8-1.51,16-3,24-4.35-7.95,1.72-15.91,3.35-23.87,5l-6,1.22-3,.62a15.64,15.64,0,0,0-2.82,1C282.42,376.4,278.7,378,274.88,379.43Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M271.15,376.84c3.58-1.93,7.26-3.63,11-5.21.47-.2.95-.39,1.43-.55a8.35,8.35,0,0,1,1.52-.41l3-.56,6-1.05c8-1.35,16-2.65,24-3.84-8,1.55-15.95,3-23.93,4.48l-6,1.09-3,.57a15.26,15.26,0,0,0-2.81.95C278.68,373.81,275,375.44,271.15,376.84Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M267.42,374.25c3.57-1.93,7.25-3.63,11-5.2.47-.2.94-.39,1.43-.56a7.72,7.72,0,0,1,1.52-.4l3-.47,6-.85c4-.56,8-1.06,12.05-1.58s8-1,12.06-1.44c-8,1.28-16,2.46-24,3.66l-6,.89-3,.49a13.77,13.77,0,0,0-2.8.94C274.94,371.23,271.23,372.85,267.42,374.25Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M253.68,426.08c4.17-1.69,8.37-3.32,12.58-4.92s8.44-3.16,12.66-4.73c2.12-.78,4.22-1.52,6.39-2.24l6.47-1.95c4.32-1.26,8.65-2.52,13-3.68-4.25,1.49-8.54,2.88-12.83,4.27l-6.44,2c-2.1.7-4.22,1.52-6.34,2.26l-12.72,4.55C262.21,423.17,258,424.66,253.68,426.08Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M313.86,405.34c4.22-1.61,8.47-3.15,12.73-4.67s8.53-3,12.8-4.46c2.14-.74,4.26-1.44,6.46-2.12l6.53-1.81c4.36-1.17,8.72-2.35,13.11-3.42-4.29,1.4-8.62,2.7-12.95,4l-6.51,1.9c-2.12.66-4.27,1.44-6.41,2.13l-12.85,4.29C322.47,402.6,318.18,404,313.86,405.34Z",
    style: {
      fill: "#dbdbdb"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Trash--inject-75"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M189.78,412.62c3.33-.48,7.62-.48,7.86,1.43s-1.27,2.94-.8,3.89,3.18,2.7,4.45,4a9.3,9.3,0,0,1,2.22,4c0,.48.8,1.27,0,2.23s-1.24,2.38-1.89,3.1-.93,1.5,0,2.77.15,4.93-1.28,6.2-5.56-1.75-6.83-1.43-1.43.94-2.54,1.74-3.82,2.71-6.67,2.71-4.29-2.55-6-3.66-3.33-1.27-4.92-1.9a9.13,9.13,0,0,1-3.66-2.7c-.31-.64-1.43-.8-1-2.54s1.27-2.23,1.27-3.66,0-1.68,0-3.3-1.28-4.48-.17-5.75,1.91-3.18,3.66-3.18,7.3,1,7.3,1a14.66,14.66,0,0,0,1.59-2.07,4.59,4.59,0,0,1,3.85-2.22A11.54,11.54,0,0,0,189.78,412.62Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M170,428.74c2.27,1.05,4.58,2,6.91,2.9s4.61,1.89,6.94,2.75a62.18,62.18,0,0,0,7,2.26,5.56,5.56,0,0,0,1.45.17l1.41-.7a22.08,22.08,0,0,0,3-1.87,8.37,8.37,0,0,0,2.31-2.37,4.69,4.69,0,0,0,.34-.67l.1-.35.05-.16s0,0,0,0a2.81,2.81,0,0,0-.61-1.06,34.07,34.07,0,0,0-5.44-4.75c-2-1.47-4-2.86-6.15-4.17-1-.68-2.1-1.34-3.18-2q-.81-.46-1.65-.87-.42-.21-.84-.39c-.27-.07-.64-.3-.85,0,.19-.3.61-.12.89-.1s.62.15.92.24c.6.2,1.19.43,1.77.67,1.16.48,2.31,1,3.44,1.56q3.36,1.71,6.56,3.74a29.61,29.61,0,0,1,6.06,4.8,4.1,4.1,0,0,1,1.1,2.21,1.89,1.89,0,0,1,0,.47l-.08.3-.16.55a5.76,5.76,0,0,1-.48,1,10.36,10.36,0,0,1-2.82,3,25.28,25.28,0,0,1-3.36,2l-.86.42-.42.2-.24.11a2.54,2.54,0,0,1-.47.14,6.06,6.06,0,0,1-2.25-.23,47.89,47.89,0,0,1-7.14-2.71A95.84,95.84,0,0,1,170,428.74Z",
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M179.48,433.05a42.74,42.74,0,0,1,4.12-5.49c.75-.88,1.56-1.69,2.37-2.51.42-.41.86-.79,1.32-1.17a7.79,7.79,0,0,1,1.67-1.11,3,3,0,0,1,.32-.11,2.14,2.14,0,0,1,.67,0,1.65,1.65,0,0,1,.87.47,6,6,0,0,1,.65.79,15.23,15.23,0,0,1,1,1.52c.55,1,1.09,2,1.54,3.1a28,28,0,0,1,2.17,6.53l-3.61-5.77c-.61-.95-1.17-1.92-1.79-2.83-.3-.46-.6-.93-.91-1.33a5.14,5.14,0,0,0-.43-.51s0,0,.16.07a.33.33,0,0,0,.24,0l-.08,0a5.9,5.9,0,0,0-1.16.76l-1.26,1-2.55,2.19C183.05,430.19,181.33,431.68,179.48,433.05Z",
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128.19,428.44c-1.8.43-4.15.65-4.38-.38s.54-1.68.23-2.17a21.87,21.87,0,0,0-2.64-1.95,5.06,5.06,0,0,1-1.42-2.06c0-.26-.5-.66-.11-1.22s.55-1.37.87-1.8a1,1,0,0,0-.14-1.52c-.58-.65-.33-2.69.39-3.46s3.13.68,3.81.44.74-.6,1.3-1.09a6.82,6.82,0,0,1,3.52-1.82c1.57-.15,2.48,1.17,3.49,1.69a13.57,13.57,0,0,0,2.8.79,5,5,0,0,1,2.14,1.29c.21.33.82.36.65,1.34s-.58,1.29-.51,2.07.08.92.17,1.81.93,2.39.39,3.14-.89,1.84-1.84,1.93-4-.15-4-.15a7.76,7.76,0,0,0-.77,1.22,2.51,2.51,0,0,1-2,1.41A6.4,6.4,0,0,0,128.19,428.44Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121.28,418.24c1-1,2-1.95,3-2.92l.77-.7.38-.34a2.13,2.13,0,0,1,.77-.38,11.93,11.93,0,0,1,2.23-.28,22.52,22.52,0,0,1,4.33.24,7.1,7.1,0,0,1,2.32.72,2.34,2.34,0,0,1,1,1.43,4.56,4.56,0,0,1,.17,1.32,14,14,0,0,1-1,4.39,20,20,0,0,1-.93,2,9,9,0,0,1-.62,1,2.57,2.57,0,0,1-1.16.9,10.93,10.93,0,0,1-4.46.29,30.41,30.41,0,0,1-4.16-.73c1.4-.11,2.79-.13,4.16-.3a12.25,12.25,0,0,0,3.78-.74c.26-.14.19-.14.4-.42s.29-.53.42-.82a14.53,14.53,0,0,0,.7-1.84,12.91,12.91,0,0,0,.76-3.73,1.54,1.54,0,0,1,.47-1,14.47,14.47,0,0,0-2.28-.52,27.1,27.1,0,0,0-4-.55,12.48,12.48,0,0,0-1.93,0c-.12,0-.24.06-.19,0l-.45.29-.89.57C123.7,416.81,122.53,417.58,121.28,418.24Z",
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.6,415.57c.08,1.34,0,2.62.13,3.79,0,.55.17,1.22.31,1.25s0,0-.05,0,0,0,.12,0a5.44,5.44,0,0,0,.72-.08c1.13-.19,2.35-.53,3.58-.79a27.09,27.09,0,0,1,3.83-.62,16.08,16.08,0,0,1-7.07,3.47,7.27,7.27,0,0,1-1.18.06,3,3,0,0,1-.81-.19,1.87,1.87,0,0,1-.76-.67,3.53,3.53,0,0,1-.32-2.46A9.51,9.51,0,0,1,125.6,415.57Z",
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110.51,402.06c-.93-2.82-.77-6.09-4-5.74s-5.08-3.63-6.51-4.58-6.51,0-7.62.95-1.59,2.81-2.7,3.63-2.7,2.09-4.13,3.36-3.49,3-2.86,6.19,2.07,4.27,3,5.87-.64,4.46.63,8.11,7.47,5.08,9.06,4.45,5.83-3.34,8.15-3.34,3,1.91,5,.8,5.08-3.5,5.24-4.45-1.75-1.79-1.11-3.28,3.18-4.28,2.86-6.14S111.22,404.22,110.51,402.06Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M104.62,396a89.41,89.41,0,0,0-11.46,4.57,6.82,6.82,0,0,0-1.14.75c-.15,0-.24.73-.33,1.17-.17,1-.3,2-.4,3-.21,2-.37,4.09-.38,6.12a18.83,18.83,0,0,0,.16,2.95,2.39,2.39,0,0,0,.21.79,4.06,4.06,0,0,0,1.12.34,31.07,31.07,0,0,0,6,.29,28.77,28.77,0,0,0,3-.23c.86-.14,2-.43,3-.6,2-.41,4.06-.8,6-1.3a14,14,0,0,0,1.37-.41.73.73,0,0,0,.23-.1s.11,0,0,0a.34.34,0,0,0-.15.2,1,1,0,0,0-.07.75.77.77,0,0,0,.2.35.66.66,0,0,0,.12.11h0l-.27-.11c-.89-.29-1.91-.53-2.9-.76l-6-1.35c-2-.44-4-.89-6.07-1.4-1-.27-2-.53-3.05-.88a5.2,5.2,0,0,1-1.71-.89,1.06,1.06,0,0,1-.18-.22,1.2,1.2,0,0,1-.15-.38c0-.13,0-.25,0-.38a1.68,1.68,0,0,1,.12-.58,5.17,5.17,0,0,1,.36-.85,26.65,26.65,0,0,1,3.93-5.05c.38-.37.75-.75,1.15-1.1.21-.18.41-.36.63-.53a3.12,3.12,0,0,1,.35-.25,1.37,1.37,0,0,1,.52-.27,1.5,1.5,0,0,1,1.18.29,5.38,5.38,0,0,1,.68.54,13.49,13.49,0,0,1,1.1,1.18,79.15,79.15,0,0,1,6.75,10.48,98.14,98.14,0,0,0-7.52-9.8c-.35-.36-.7-.72-1.06-1a2.68,2.68,0,0,0-.82-.52l-.15.11a1.65,1.65,0,0,0-.27.21c-.18.15-.36.33-.53.5-.36.35-.7.72-1,1.09a25.65,25.65,0,0,0-3.46,4.87,3.12,3.12,0,0,0-.22.59c0,.06-.06.19,0,.17h0a.56.56,0,0,0-.08-.21l-.05-.07a5.88,5.88,0,0,0,1.09.42c.93.3,1.93.55,2.92.79,2,.47,4,.89,6,1.3l7.76,1.49c1,.23.35.2,1.44.54l.45.17a1.85,1.85,0,0,1,.31.16,1.17,1.17,0,0,1,.28.23,1.08,1.08,0,0,1,.25.43,1.16,1.16,0,0,1-.08.85,2.07,2.07,0,0,1-.43.46,1.54,1.54,0,0,1-.29.18,2.55,2.55,0,0,1-.47.21,12.67,12.67,0,0,1-1.6.5c-2.07.5-4.11.86-6.14,1.24-1.07.18-1.91.38-3.1.57a31.77,31.77,0,0,1-3.2.2,32.13,32.13,0,0,1-6.38-.42,4.92,4.92,0,0,1-1.8-.66,2,2,0,0,1-.72-1.08,3.87,3.87,0,0,1-.19-.92,20.69,20.69,0,0,1,0-3.24c.11-2.11.36-4.17.67-6.24.16-1,.33-2.06.56-3.09.19-.53.07-1,.7-1.71a5.9,5.9,0,0,1,1.46-.89,50.66,50.66,0,0,1,5.91-2.08C100.6,397,102.59,396.4,104.62,396Z",
    style: {
      fill: "#c7c7c7"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Character--inject-75"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M265.83,228.9c32.5,32.93,73.37,102.21,65.75,116.26-8.48,15.64-53.73-30.53-53.56-33.22.14-2-15.78-44.13-27.86-74.73S257.8,220.75,265.83,228.9Z",
    style: {
      fill: "rgb(247, 169, 160)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M277.72,312c-1.38-4.5-23-60-29.23-77.55s-.45-23,17.23-6.9S322.16,297.31,331,325.8c8.52,27.46-5.61,27.46-24.26,14.8C291.47,330.24,277.72,312,277.72,312Z",
    style: {
      fill: "#009595"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M262.65,229.36a13,13,0,0,1-1.1,3.55,13.18,13.18,0,0,1-2,3.15,12.87,12.87,0,0,1,1.1-3.55A13.18,13.18,0,0,1,262.65,229.36Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M318.21,302.51a13.66,13.66,0,0,1-1.1,3.56,12.91,12.91,0,0,1-2,3.15,14.28,14.28,0,0,1,3.08-6.71Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M299.05,273.36a14.3,14.3,0,0,1-3.08,6.7,12.89,12.89,0,0,1,1.11-3.55A13.18,13.18,0,0,1,299.05,273.36Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M280.33,271.17a13.23,13.23,0,0,1-3.55-1.11,12.87,12.87,0,0,1-3.15-2,14.3,14.3,0,0,1,6.7,3.08Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M298.27,300.65a13.66,13.66,0,0,1-3.56-1.1,13.22,13.22,0,0,1-3.15-2,14.28,14.28,0,0,1,6.71,3.08Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M283.69,250.15a13.29,13.29,0,0,1-3.56-1.1,12.91,12.91,0,0,1-3.15-2,12.89,12.89,0,0,1,3.55,1.11A13.44,13.44,0,0,1,283.69,250.15Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M268.58,283.91a14.39,14.39,0,0,1,2.56,6.92,14.39,14.39,0,0,1-2.56-6.92Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M306.11,319a13,13,0,0,1,1.73,3.3,12.9,12.9,0,0,1,.83,3.62,14.39,14.39,0,0,1-2.56-6.92Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M285.3,315.93a12.24,12.24,0,0,1-3.06,1.64l-.65-.78.08,0A13,13,0,0,1,285.3,315.93Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M322.51,338.56a13.4,13.4,0,0,1,3.3-1.74,12.9,12.9,0,0,1,3.62-.83,12.81,12.81,0,0,1-3.29,1.73A13.26,13.26,0,0,1,322.51,338.56Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M263,255.58a13,13,0,0,1-3.3,1.73,14.23,14.23,0,0,1-2.5.69l-.18-.49a14.77,14.77,0,0,1,2.35-1.1A12.89,12.89,0,0,1,263,255.58Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M273.84,352.76H150.3s19.64-96.89,67-138.83c5.85-5.18,19.06-4,27.68.28,3.07,1.53,14.12,17,17.27,31.59S274.18,352.32,273.84,352.76Z",
    style: {
      fill: "#009595"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M263.34,251.84c1,3.26,1.77,6.65,2.43,10,0-.13,0-.26,0-.4,0-1.9.06-3.85.27-5.75,0-.1.17-.13.18,0a28.82,28.82,0,0,1,.16,5.8c0,.91-.11,1.83-.18,2.74.26,1.52.49,3.05.68,4.56.36,2.89,1.33,13.62,1.41,15.75,0,.45-.49.53-.62.06-.58-2.16-2.12-13.22-2.61-16.07a153.59,153.59,0,0,1-1.95-16.7C263.12,251.73,263.31,251.73,263.34,251.84Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M225.06,239.22a14.28,14.28,0,0,1-3.08,6.71,12.78,12.78,0,0,1,1.11-3.55A13.24,13.24,0,0,1,225.06,239.22Zm-16.74,49.2a12.94,12.94,0,0,0-1.1,3.56,13,13,0,0,0,2-3.16,13.22,13.22,0,0,0,1.1-3.55A12.91,12.91,0,0,0,208.32,288.42ZM168.19,306a13.22,13.22,0,0,0-1.1,3.55,12.91,12.91,0,0,0,2-3.15,13.29,13.29,0,0,0,1.1-3.56A13.28,13.28,0,0,0,168.19,306Zm29.5,31.54a12.87,12.87,0,0,0-1.1,3.55,12.91,12.91,0,0,0,2-3.15,13.66,13.66,0,0,0,1.1-3.56A13.16,13.16,0,0,0,197.69,337.58Zm51.5-60.95a13.22,13.22,0,0,0-1.1,3.55,12.91,12.91,0,0,0,2-3.15,13.22,13.22,0,0,0,1.1-3.55A13.54,13.54,0,0,0,249.19,276.63Zm16.23,33.47a12.94,12.94,0,0,0-1.1,3.56,12.87,12.87,0,0,0,2-3.15A13.3,13.3,0,0,0,267.4,307,12.91,12.91,0,0,0,265.42,310.1Zm-39.27,24.12a13.29,13.29,0,0,0-1.1,3.56,12.91,12.91,0,0,0,2-3.15,13.29,13.29,0,0,0,1.1-3.56A13.22,13.22,0,0,0,226.15,334.22ZM188.52,269a13,13,0,0,0-1.1,3.55,13.18,13.18,0,0,0,2-3.15,12.87,12.87,0,0,0,1.1-3.55A13.18,13.18,0,0,0,188.52,269Zm46.7-11a12.87,12.87,0,0,0-3.55-1.1,12.91,12.91,0,0,0,3.15,2,13.58,13.58,0,0,0,3.55,1.1A12.91,12.91,0,0,0,235.22,258ZM243,297.71a12.87,12.87,0,0,0-3.55-1.1,12.91,12.91,0,0,0,3.15,2,13.7,13.7,0,0,0,3.55,1.1A12.91,12.91,0,0,0,243,297.71Zm-72.64,42.12a13,13,0,0,0-3.55-1.1,12.91,12.91,0,0,0,3.15,2,13.58,13.58,0,0,0,3.55,1.1A12.91,12.91,0,0,0,170.37,339.83Zm73.92,8.05a13,13,0,0,0-3.56-1.1,13.38,13.38,0,0,0,3.15,2l.76.33,2,.13A14.59,14.59,0,0,0,244.29,347.88Zm-46.15-40.23a13,13,0,0,0-3.55-1.1,12.87,12.87,0,0,0,3.15,2,13.23,13.23,0,0,0,3.55,1.11A12.91,12.91,0,0,0,198.14,307.65Zm37.08-84.88a12.87,12.87,0,0,0-3.55-1.1,12.87,12.87,0,0,0,3.15,2,13.23,13.23,0,0,0,3.55,1.11A12.91,12.91,0,0,0,235.22,222.77Zm8,18.44A12.81,12.81,0,0,0,245,244.5a14.39,14.39,0,0,0-2.56-6.92A12.89,12.89,0,0,0,243.22,241.21Zm19.62,92a13,13,0,0,0,1.73,3.29,14.39,14.39,0,0,0-2.56-6.92A13,13,0,0,0,262.84,333.16Zm-53-68.84a12.81,12.81,0,0,0,1.73,3.29,12.9,12.9,0,0,0-.83-3.62,13.4,13.4,0,0,0-1.74-3.3A13.26,13.26,0,0,0,209.85,264.32ZM225.1,304.8a13.34,13.34,0,0,0,1.74,3.29,14.27,14.27,0,0,0-2.57-6.92A13.33,13.33,0,0,0,225.1,304.8Zm-70.79,47.45c0,.17,0,.34,0,.51h.32Q154.51,352.51,154.31,352.25Zm34.78-.16a13.4,13.4,0,0,0-1.74-3.3,13.24,13.24,0,0,0,.83,3.63l.13.34h1C189.24,352.54,189.17,352.31,189.09,352.09ZM182,323.56a13,13,0,0,0,1.73,3.3,12.89,12.89,0,0,0-.83-3.63,13.16,13.16,0,0,0-1.74-3.29A13.27,13.27,0,0,0,182,323.56Zm29.91-95.24a13.16,13.16,0,0,0,1.74,3.29,14.55,14.55,0,0,0-2.57-6.91A13.26,13.26,0,0,0,211.9,228.32ZM245,321.67a12.81,12.81,0,0,0,3.29-1.73,12.9,12.9,0,0,0-3.62.83,13.13,13.13,0,0,0-3.29,1.73A12.9,12.9,0,0,0,245,321.67Zm-32.34,29.75a13,13,0,0,0,3.3-1.73,12.89,12.89,0,0,0-3.63.83,13.13,13.13,0,0,0-3.29,1.73A12.9,12.9,0,0,0,212.62,351.42Zm-55-26.94c-.08.28-.17.57-.25.84a10.1,10.1,0,0,0,1.68-1A9.64,9.64,0,0,0,157.62,324.48Zm28.2-34.26a12.85,12.85,0,0,0,3.29-1.74,14.64,14.64,0,0,0-6.92,2.57A13.24,13.24,0,0,0,185.82,290.22ZM211.75,323a12.81,12.81,0,0,0,3.29-1.73,13,13,0,0,0-3.63.83,13.34,13.34,0,0,0-3.29,1.74A13.34,13.34,0,0,0,211.75,323ZM227.15,276a12.85,12.85,0,0,0,3.29-1.74,13,13,0,0,0-3.63.84,13.14,13.14,0,0,0-3.29,1.73A13.24,13.24,0,0,0,227.15,276Zm32.59-18.69a13,13,0,0,0,3.3-1.73,14.39,14.39,0,0,0-6.92,2.56A12.9,12.9,0,0,0,259.74,257.31Zm-58.28-10.93a12.81,12.81,0,0,0,3.29-1.73,12.82,12.82,0,0,0-3.62.83,13.36,13.36,0,0,0-3.3,1.73A12.89,12.89,0,0,0,201.46,246.38Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M244.43,234.68C237,236.14,224.68,224.32,220,215c-.32-.65.9-7.24,2-15.32.66-4.9,1.27-10.38,1.46-15.42,0-1,31.31,8.92,31.31,8.92s-3.52,10.44-3.81,19.22a11.62,11.62,0,0,0,.13,2.08,3.06,3.06,0,0,1,0,.35C251.64,218.73,251.65,233.26,244.43,234.68Z",
    style: {
      fill: "rgb(247, 169, 160)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M247.9,214.82a19.23,19.23,0,0,0,3.25,0,3.07,3.07,0,0,0,0-.34,10.76,10.76,0,0,1-.13-2.08c.29-8.78,3.8-19.22,3.8-19.22s-25.37-8.08-30.43-8.93C225.11,190.06,229.28,213.67,247.9,214.82Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M215.72,153.29c-2.43,11.47,6.27,43.23,14.85,49.73,12.42,9.43,31.37,8.79,39-5.83,7.42-14.17-4.66-55.36-14.1-61.13C241.59,127.57,219.32,136.35,215.72,153.29Z",
    style: {
      fill: "rgb(247, 169, 160)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M248.3,171.59c0-.08-.14.14-.11.23.64,2.12,1,4.67-.72,5.9-.06,0,0,.14.05.11C249.79,176.86,249.25,173.5,248.3,171.59Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M245.79,169.86c-3.52.67-1.93,7.65,1.33,7S248.74,169.31,245.79,169.86Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M261.51,168.28c0-.09.19.06.21.15.42,2.18,1.27,4.6,3.39,4.88.07,0,.08.12,0,.12C262.66,173.64,261.56,170.41,261.51,168.28Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M262.92,165.58c3.42-1.06,5.28,5.86,2.11,6.84S260.06,166.46,262.92,165.58Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M242.66,169.19a28.35,28.35,0,0,0,2.85-.73,4.85,4.85,0,0,0,2.76-1.3,1.52,1.52,0,0,0-.09-1.85,3.74,3.74,0,0,0-3.73-.71,5.5,5.5,0,0,0-3.38,2.1A1.62,1.62,0,0,0,242.66,169.19Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M264.82,161.45a28.87,28.87,0,0,1-2.94-.09,4.75,4.75,0,0,1-3-.66,1.51,1.51,0,0,1-.32-1.82,3.76,3.76,0,0,1,3.49-1.52,5.51,5.51,0,0,1,3.75,1.31A1.61,1.61,0,0,1,264.82,161.45Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.87,191.37c.64.39,1.31,1,2.11.86a5.93,5.93,0,0,0,2.2-1.07.08.08,0,0,1,.12.09,3,3,0,0,1-2.48,1.79,2.34,2.34,0,0,1-2.13-1.52C250.63,191.4,250.78,191.32,250.87,191.37Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M251.67,184.38a7.58,7.58,0,0,0,5.66,2.16,9.51,9.51,0,0,0,2.68-.48,3.54,3.54,0,0,0,.49-.18,2.92,2.92,0,0,0,.46-.18.53.53,0,0,0,.32-.58v0a.86.86,0,0,0-.07-.21v0l0-.19c-.33-1.67-1.07-4.17-1.07-4.17.68.17,4.1.86,3.85,0-2.07-7.11-4.37-15-7.93-21.64a.2.2,0,0,0-.38.14c1.72,6.91,4.64,13.47,6.47,20.38a13,13,0,0,0-3.71-.26c-.22.12,1.51,4.79,1.6,5.56a.17.17,0,0,1,0,.08c-2.71,1-5,.63-8.16-.63C251.64,184.05,251.5,184.24,251.67,184.38Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M221.93,181.64s-11.62-17.2-11.13-27.5c.22-4.65,6.38-8.09,6.38-8.09A10.47,10.47,0,0,1,220,135.36c5.23-5.44,18.55-4.94,18.55-4.94s8-12.86,20.4-8.53,5.17,18.51,5.17,18.51,4.78,6.11-5.88,11.61c-10.38,5.35-32.32,1.69-32.32,1.69a75.94,75.94,0,0,1,.78,22.5A6.9,6.9,0,0,1,221.93,181.64Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M240.62,130.48a21.46,21.46,0,0,0-8.64-1.14,23,23,0,0,0-7.65,1.59c-4.3,1.79-8,5.21-8.53,10a9,9,0,0,0,2,6.66c.06.07.17,0,.11-.12-3-3.34-1.78-8.83,1-11.89,3.12-3.47,8.09-5,12.6-5.39a38.39,38.39,0,0,1,9,.5A.13.13,0,0,0,240.62,130.48Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M267.9,127.33c-1.18-3.36-4.21-5.4-7.54-6.29a17.77,17.77,0,0,0-11.5,1,22.37,22.37,0,0,0-9.07,7.45c0,.07.07.16.12.09,4.31-5.64,11.32-9.08,18.47-7.93,3.19.51,6.44,2,8.05,4.93a10.69,10.69,0,0,1,.18,9.05c-1.47,3.45-4.39,6.15-7.43,8.23-.07,0,0,.16.07.12a20.51,20.51,0,0,0,7.46-7.05A11.63,11.63,0,0,0,267.9,127.33Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M260.87,152.45a36.78,36.78,0,0,1-15.18,3.42,74.74,74.74,0,0,1-16.21-1.41c-3.11-.58-6.2-1.29-9.28-2.05-.1,0-.13.12,0,.15a81.85,81.85,0,0,0,16.73,4.27,41.17,41.17,0,0,0,15.9-.94,34.9,34.9,0,0,0,8.13-3.34C261,152.52,260.93,152.42,260.87,152.45Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M249.05,184.31a8.87,8.87,0,1,1,7-12.15h0a8.88,8.88,0,0,1-4.86,11.57A8.65,8.65,0,0,1,249.05,184.31Zm-2.29-16.4a7.59,7.59,0,0,0-1.84.49,7.71,7.71,0,1,0,1.84-.49Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M268.73,179.05c-3.37.47-6.9-2.55-8.07-7a10.61,10.61,0,0,1,.25-6.48,5.52,5.52,0,0,1,9.15-2.39,10.56,10.56,0,0,1,3.38,5.52c1.24,4.74-.62,9.34-4.14,10.26A3.82,3.82,0,0,1,268.73,179.05Zm-3.18-16.22a3.12,3.12,0,0,0-.44.09A4.69,4.69,0,0,0,262,166a9.4,9.4,0,0,0-.2,5.75c1.07,4.1,4.29,6.82,7.19,6.06s4.37-4.71,3.29-8.81a9.35,9.35,0,0,0-3-4.91A4.92,4.92,0,0,0,265.55,162.83Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M256,173.23l-1-.69c1-1.43,3.64-3.69,6.33-2l-.64,1C258.33,170,256.1,173.1,256,173.23Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M218.34,185.44l-1.16-.26c.12-.54,1.26-5.3,3.71-6.39s18.06-3.59,18.73-3.7l.19,1.17c-4.52.74-16.67,2.83-18.44,3.61S218.63,184.13,218.34,185.44Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M226.88,179.85s-8.4-9.63-12.85-6.53,2.65,17.62,8.42,19.09a5.68,5.68,0,0,0,7.24-3.85Z",
    style: {
      fill: "rgb(247, 169, 160)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M216.17,177.43c-.09,0-.09.13,0,.15,4.06,1.16,6.49,4.55,8.33,8.14-1.31-1.32-3-1.94-4.75-.35-.1.08,0,.23.12.19a3.49,3.49,0,0,1,3.95.8,17.13,17.13,0,0,1,2.17,2.9c.21.33.82.07.65-.31a.36.36,0,0,1,0-.09C226.15,183.89,221.55,177.36,216.17,177.43Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M331.58,345.16c-7.31,10.46-27.22,12.45-76.88,22.18-6.87,1.35-29.41-44.59-22.15-46.4,9.15-2.29,45.15-9.18,47.85-9.35C303.14,310.15,336.54,338.06,331.58,345.16Z",
    style: {
      fill: "rgb(247, 169, 160)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M242.49,318.67s-21,3.18-31.58,8.27c-14.1,6.82-23.48,18.51-27.11,23.65-7.58,10.73-18.5,41.9-10.07,46.61,7.63,4.26,17.18-28.16,17.18-28.16s-15.19,31.45-5.06,34.9,19.08-34.83,19.08-34.83-14.89,32.67-3.88,34.57c8.33,1.43,18.38-32.78,18.38-32.78s-12.6,28.17-4.11,30c9.39,2,20.65-29,20.65-29,22.38,1.06,33.46-7.6,40.62-14.69C278.32,355.55,242.49,318.67,242.49,318.67Z",
    style: {
      fill: "rgb(247, 169, 160)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M195.47,357.82c-1.92,3.63-3.89,7.29-5.47,11.08s-3.05,7.64-4.28,11.56c-3,9.61-3.4,16.1-3.33,15.7,1.59-9.42,7.07-23.07,8.66-26.86s3-7.64,4.57-11.43C195.66,357.78,195.51,357.73,195.47,357.82Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M209.25,363.31c-2.25,4.74-4.65,9.36-6.69,14.21S199,387.09,197.33,392c-.13.38.12.33.27,0,1.88-4.87,4-9.24,6-14.09s3.71-9.78,5.82-14.54C209.4,363.28,209.29,363.24,209.25,363.31Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M221.93,365.89c-3.81,7.07-6.31,14.84-8.57,22.51-.12.38.2.28.33-.11,2.71-7.53,4.78-13.46,8.49-22.27C222.24,365.89,222,365.74,221.93,365.89Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M238.1,318.67l43.5,48.45s44-10.1,50.48-21.38c4.27-7.43-28.89-37.41-53.9-33.9Z",
    style: {
      fill: "#009595"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M276.73,348.9a13.22,13.22,0,0,1-1.1,3.55,12.78,12.78,0,0,1-2,3.16,13.29,13.29,0,0,1,1.1-3.56A12.91,12.91,0,0,1,276.73,348.9ZM307,346.19a13.22,13.22,0,0,0-1.1,3.55,12.91,12.91,0,0,0,2-3.15,13.29,13.29,0,0,0,1.1-3.56A13.28,13.28,0,0,0,307,346.19ZM285.4,336a12.94,12.94,0,0,0-3.56-1.1,12.91,12.91,0,0,0,3.15,2,13.29,13.29,0,0,0,3.56,1.1A12.91,12.91,0,0,0,285.4,336Zm21.54-13.34a12.81,12.81,0,0,0,1.73,3.29,12.9,12.9,0,0,0-.83-3.62,13,13,0,0,0-1.73-3.3A12.89,12.89,0,0,0,306.94,322.67Zm-44.1,10.49a13,13,0,0,0,1.73,3.29,14.39,14.39,0,0,0-2.56-6.92A13,13,0,0,0,262.84,333.16ZM245,321.67a12.81,12.81,0,0,0,3.29-1.73,12.9,12.9,0,0,0-3.62.83,13.13,13.13,0,0,0-3.29,1.73A12.9,12.9,0,0,0,245,321.67Zm37-4a12.81,12.81,0,0,0,3.29-1.73,13,13,0,0,0-3.63.83,13.83,13.83,0,0,0-3.29,1.73A12.89,12.89,0,0,0,282,317.66Zm13.7,42.6a12.76,12.76,0,0,0,3.3-1.74,13.26,13.26,0,0,0-3.63.84,12.81,12.81,0,0,0-3.29,1.73A13.26,13.26,0,0,0,295.71,360.26Zm32.71-24.16a15.5,15.5,0,0,0-2.61.72,13.4,13.4,0,0,0-3.3,1.74,13.26,13.26,0,0,0,3.63-.84,14.22,14.22,0,0,0,2.58-1.24Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M308.05,319.76c-4-2.92-15.39-9.73-29.87-7.92-.12,0-.13.22,0,.22,10.92-.31,25.65,5.4,29.77,7.88C308.06,320,308.15,319.83,308.05,319.76Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M293.5,359c-4.5-5.59-9.29-10.92-14.1-16.25s-9.61-10.66-14.55-15.87c-2.79-2.94-5.57-5.91-8.47-8.75-.07-.07-.22,0-.15.12,4.49,5.58,9.27,10.94,14,16.29s9.61,10.67,14.49,15.94c2.76,3,5.57,5.9,8.47,8.74C293.36,359.37,293.63,359.17,293.5,359Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M253.47,221.14a.05.05,0,1,0-.1,0c.87,6.68,2.46,22.21-8.13,22-4.26-.09-8.31-2.47-11.71-4.84a59.44,59.44,0,0,1-9.55-8.44,88.42,88.42,0,0,1-9.12-11.06c-.11-.17-.36,0-.24.2,2.78,3.93,5.15,8,8.31,11.71a51.34,51.34,0,0,0,10.32,9.37c3.63,2.42,7.93,4.78,12.43,4.66,4.29-.11,7.21-3,8.19-7C255.16,232.45,254.66,226.39,253.47,221.14Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M251.14,214.62l-7.72,18.58L220.5,209.32l-6.66,7.5s22.26,37.79,22.42,36.09l7.88-16,11,11.32-.58-28.11Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M255.62,234.32c-.25-4.64-.38-9.32-.84-13.94,0-.17-.28-.24-.32,0-1,4.47.08,22.2,0,26.45l-.05-.05c-.46-.49-10.18-10-10.28-9.82-1.7,2.54-7.48,14.19-7.88,15.25-3.52-6-17-27.83-21.21-33.51a.16.16,0,0,0-.28.15c3.1,6.34,21,35.73,21.25,35.65.19.15,7.37-14.21,8.24-16.92,1.64,2.06,11.44,12.74,11.48,12.05A146.55,146.55,0,0,0,255.62,234.32Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M293,285.77s4.77,10.81-2.86,13.46-10.6-8.78-10.6-8.78Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M252.39,212.43h0l1.7-11.43.53-3.78,2.8,2.61,8.43,7.92h0v0l27.27,78.46-13.47,4.68L252.4,212.43Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "254.08 200.98 254.63 197.21 257.43 199.82 254.08 200.98",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 277.68,
    y: 285.76,
    width: 16.64,
    height: 3.3,
    transform: "translate(650.51 464.99) rotate(160.83)",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 276.48,
    y: 282.31,
    width: 16.64,
    height: 3.3,
    transform: "translate(647.05 458.67) rotate(160.83)",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "292.12 279.67 287.05 281.44 279.98 252.08 281.88 251.54 292.12 279.67",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M195.62,237.29C164,276.8,135.3,333.66,141.12,354.22c2.13,7.52,15.72,20,36.13,13.25,23-7.62,51.65-26.36,78.35-46.27,5.66-4.22-40.77-39.45-46.9-35-2.85,2.06-10.63,9.32-11.81,8.76-1.77-.85,7.59-20.3,15.52-50.8C220.77,212,209.38,220.12,195.62,237.29Z",
    style: {
      fill: "rgb(247, 169, 160)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M275.25,233.79c4.29,5.23-9.52,14.71-9.52,14.71a12.5,12.5,0,0,1,8.23,2.09c4.12,3.08,1.09,10.89,1.09,10.89a15.45,15.45,0,0,1,8.34,3.58c3.64,3.35,1.71,11.66,1.71,11.66a13.51,13.51,0,0,1,5.34,7.77c1.77,8.49-7.79,17.65-13.8,23.54S248,325,244,327.53l-38.13-38.29s19.47-34.08,27.53-40C240.14,244.25,268.7,225.78,275.25,233.79Z",
    style: {
      fill: "rgb(247, 169, 160)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M265.5,248.44c-8.49,3.57-16.11,9.16-23.4,14.64a.16.16,0,0,0,.19.25c7.19-5.53,16-9.28,23.43-14.51A.22.22,0,0,0,265.5,248.44Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M274.43,261.1a24,24,0,0,0-5.09,3.67q-2.56,2.14-5,4.36-5,4.44-9.76,9.13c-.14.14,0,.39.19.25q5-4.42,10.13-8.64,2.59-2.12,5.2-4.17a28.34,28.34,0,0,0,4.75-4.12A.31.31,0,0,0,274.43,261.1Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M285,276.84c-1.68.69-3.1,2.34-4.41,3.56-1.49,1.38-3,2.75-4.49,4.11-3,2.73-6,5.46-9.11,8.08-.15.13,0,.38.19.25,3.17-2.65,6.36-5.25,9.5-7.93q2.31-2,4.61-4c1.29-1.13,3.05-2.4,3.85-4A.11.11,0,0,0,285,276.84Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M243.67,329.91a49.28,49.28,0,0,1,5.67-4.76,48.19,48.19,0,0,1,6.26-3.95,47.33,47.33,0,0,1-5.67,4.76A48.19,48.19,0,0,1,243.67,329.91Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M198.19,292.7s8.61-25.2,14.52-45.65,7.78-39.45-14-16.36S138,321.83,138.6,348.63c.16,7.79,8.52,22.8,30.09,22.3S249,334.82,249,334.82l-43.57-47.41Z",
    style: {
      fill: "#009595"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M208.27,290.55a8.89,8.89,0,0,1-1.05,1.43,9.72,9.72,0,0,1,.5-2ZM168.19,306a13.22,13.22,0,0,0-1.1,3.55,12.91,12.91,0,0,0,2-3.15,13.29,13.29,0,0,0,1.1-3.56A13.28,13.28,0,0,0,168.19,306Zm29.5,31.54a12.87,12.87,0,0,0-1.1,3.55,12.91,12.91,0,0,0,2-3.15,13.66,13.66,0,0,0,1.1-3.56A13.16,13.16,0,0,0,197.69,337.58Zm-55.45,4.52a13.22,13.22,0,0,0-1.1,3.55,12.91,12.91,0,0,0,2-3.15,13.33,13.33,0,0,0,1.1-3.55A13.22,13.22,0,0,0,142.24,342.1Zm83.91-7.88a13.29,13.29,0,0,0-1.1,3.56,12.91,12.91,0,0,0,2-3.15,13.29,13.29,0,0,0,1.1-3.56A13.22,13.22,0,0,0,226.15,334.22ZM188.52,269a13,13,0,0,0-1.1,3.55,13.18,13.18,0,0,0,2-3.15,12.87,12.87,0,0,0,1.1-3.55A13.18,13.18,0,0,0,188.52,269Zm-6.73-16.43a11.3,11.3,0,0,0,2.72.76,11.18,11.18,0,0,0-2.21-1.5Zm-29.46,51.65h0c-.14.29-.28.58-.41.88h0a13.66,13.66,0,0,0,3.56,1.1A13.16,13.16,0,0,0,152.33,304.19Zm18,35.64a13,13,0,0,0-3.55-1.1,12.91,12.91,0,0,0,3.15,2,13.58,13.58,0,0,0,3.55,1.1A12.91,12.91,0,0,0,170.37,339.83Zm27.77-32.18a13,13,0,0,0-3.55-1.1,12.87,12.87,0,0,0,3.15,2,13.23,13.23,0,0,0,3.55,1.11A12.91,12.91,0,0,0,198.14,307.65Zm-43,48.23a12.81,12.81,0,0,0,1.73,3.29,12.9,12.9,0,0,0-.83-3.62,13,13,0,0,0-1.73-3.3A12.89,12.89,0,0,0,155.14,355.88Zm33-3.46a13.16,13.16,0,0,0,1.74,3.29,13.26,13.26,0,0,0-.83-3.62,13.4,13.4,0,0,0-1.74-3.3A13.24,13.24,0,0,0,188.18,352.42ZM182,323.56a13,13,0,0,0,1.73,3.3,12.89,12.89,0,0,0-.83-3.63,13.16,13.16,0,0,0-1.74-3.29A13.27,13.27,0,0,0,182,323.56Zm-13.81-40.1a12.81,12.81,0,0,0,1.73,3.29,14.39,14.39,0,0,0-2.56-6.92A12.89,12.89,0,0,0,168.18,283.46Zm43.72-55.14a13.16,13.16,0,0,0,1.74,3.29,14.55,14.55,0,0,0-2.57-6.91A13.26,13.26,0,0,0,211.9,228.32Zm-10.44,18.06a12.81,12.81,0,0,0,3.29-1.73,12.82,12.82,0,0,0-3.62.83,13.36,13.36,0,0,0-3.3,1.73A12.89,12.89,0,0,0,201.46,246.38Zm11.16,105a13,13,0,0,0,3.3-1.73,12.89,12.89,0,0,0-3.63.83,13.13,13.13,0,0,0-3.29,1.73A12.9,12.9,0,0,0,212.62,351.42ZM155.76,326a12.81,12.81,0,0,0,3.29-1.73,13,13,0,0,0-3.63.83,13.34,13.34,0,0,0-3.29,1.74A13.26,13.26,0,0,0,155.76,326Zm18.35,37.09a13,13,0,0,0,3.29-1.73,12.89,12.89,0,0,0-3.63.83,13.34,13.34,0,0,0-3.29,1.74A13.34,13.34,0,0,0,174.11,363.11Zm11.71-72.89a12.85,12.85,0,0,0,3.29-1.74,14.64,14.64,0,0,0-6.92,2.57A13.24,13.24,0,0,0,185.82,290.22ZM211.75,323a12.81,12.81,0,0,0,3.29-1.73,13,13,0,0,0-3.63.83,13.34,13.34,0,0,0-3.29,1.74A13.34,13.34,0,0,0,211.75,323Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M235.52,338.42c-4.5-5.58-9.29-10.92-14.1-16.24s-9.61-10.67-14.55-15.88c-2.8-2.94-5.57-5.9-8.47-8.74-.07-.08-.22,0-.15.12,4.49,5.57,9.27,10.94,14,16.28s9.61,10.68,14.49,15.94c2.76,3,5.57,5.9,8.47,8.75C235.38,338.79,235.65,338.59,235.52,338.42Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M211.11,261.86c-.85,1.25-1.62,2.55-2.34,3.87.24-.68.49-1.36.72-2.05,1-2.77,1.86-5.56,2.79-8.35.06-.17-.24-.29-.31-.12-1,2.41-2,4.8-2.95,7.22s-1.83,4.8-2.75,7.2c-1.85,4.85-3.69,9.69-5.4,14.59-1,2.77-1.86,5.55-2.67,8.38,0,.11.15.19.2.08,2.15-4.7,4-9.53,5.83-14.38q1.74-4.76,3.46-9.53c1.25-2.24,2.46-4.51,3.56-6.83A.08.08,0,0,0,211.11,261.86Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M206.06,288.27s-.68-.54-.71-.57c-2.15,1.88-4.48,3.52-6.7,5.29-1.18.95-9.94,7.9-12.94,10.43-7.11,6-14,12.23-20.82,18.61-3.39,3.19-6.72,6.45-10,9.74s-6.63,6.63-9.78,10.11a.08.08,0,0,1-.12-.1c3.42-4,6.83-8.09,10.4-12a239.91,239.91,0,0,1,20.09-19.61q5.31-4.59,10.83-8.93c2.42-1.91,10.46-8.11,11.61-9,2.37-1.79,4.75-3.72,7.15-5.31.09-.06,1.09,1.19,1.12,1.21S206.11,288.36,206.06,288.27Z",
    style: {
      fill: "#263238"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Mug--inject-75"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 92.67,
    y: 382.08,
    width: 23.67,
    height: 3.69,
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 92.67,
    y: 382.08,
    width: 23.67,
    height: 2.44,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.57,372.15a13.41,13.41,0,0,0,13.33,5.7,13.19,13.19,0,0,0,2.4-.69,17.19,17.19,0,0,0,3.35-1.76l-3-4.46a9.86,9.86,0,0,1-1.78,1c-5.63,2.56-9.2-1.89-9.9-2.9-3.25-4.56-4.41-15-1.12-19,.22-.3,1.17-.77,5,0,.7.16,1.5.34,2.4.59a9.71,9.71,0,0,0,2.17.46l.09-2.67.26-2.68c-.24,0-.63-.15-1.13-.29a34.07,34.07,0,0,0-5.38-1.12c-2.8-.29-5.74.05-7.55,2.26C58.34,353.2,60.51,366.43,64.57,372.15Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.64,370.94a9.86,9.86,0,0,1-1.78,1l1.44,5.21a17.19,17.19,0,0,0,3.35-1.76Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.23,344.4l1.59,5.71c.7.16,1.5.34,2.4.59a9.71,9.71,0,0,0,2.17.46l.09-2.67.26-2.68c-.24,0-.63-.15-1.13-.29A34.07,34.07,0,0,0,71.23,344.4Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136,337.42s-2.84,24.12-7.75,34.29S116.49,383,112.24,383H96.76c-4.25,0-11.09-1.14-16-11.28S73,337.42,73,337.42Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132.94,356c-.23,1-.45,2-.68,3.06H76.74c-.23-1-.45-2-.68-3.06Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.51,362.11c-.6,2.28-1.24,4.47-1.95,6.4H79.44c-.71-1.93-1.35-4.12-2-6.4Z",
    style: {
      fill: "#37474f"
    }
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWritingVector);
export default __webpack_public_path__ + "static/media/writing_vector.1d4aa771acef5e1731075b783d9bb128.svg";
export { ForwardRef as ReactComponent };